module.exports = "./assets/images/avatar-7.svg";